module.exports = __webpack_public_path__ + "static/media/helicopter.3757b786.jpg";